export class ClientPageManager {};
